import React from 'react';

const AttendanceTable = ({ data }) => {
  // Extract all dates from the dataset to form the header row
  const allDates = [
    ...new Set(
      data.flatMap((student) =>
        student.map((entry) => entry.dateEntity.date),
      ),
    ),
  ].sort();

  const formatDate = (dateString) => {
    const date = new Date(dateString);
    const day = String(date.getDate()).padStart(2, '0');
    const month = String(date.getMonth() + 1).padStart(2, '0');
    const year = date.getFullYear();
    return `${day}/${month}/${year}`;
  };

  return (
    <div className="overflow-x-auto shadow-lg rounded-lg mx-auto">
      <div className="max-h-[70vh] overflow-y-auto">
        <table className="min-w-full border-collapse bg-white relative">
          <thead className="bg-gradient-to-r from-cyan-900 to-blue-900 text-white text-sm md:text-base lg:text-lg sticky top-0 z-30 shadow-md">
            <tr>
              <th
                className="
    py-3 px-4 font-semibold text-right border-b border-blue-200
    sticky left-0 z-40 bg-cyan-900
    shadow-[4px_0_6px_-1px_rgba(0,0,0,0.2)]
  "
              >
                Name Arabic
              </th>
              {allDates.map((date) => (
                <th
                  key={date}
                  className="py-3 px-4 font-semibold border-b border-blue-200"
                >
                  {formatDate(date)}
                </th>
              ))}
            </tr>
          </thead>
          <tbody>
            {data.map((studentRecords, index) => {
              if (
                studentRecords === undefined ||
                studentRecords === null ||
                studentRecords?.length <= 0
              )
                return null;
              const studentName = `${studentRecords[0].studentEntity.firstNameArabic} , ${studentRecords[0].studentEntity.lastNameArabic}`;
              // Create a mapping of dates to records for the current student
              const recordsByDate = studentRecords.reduce(
                (acc, record) => {
                  acc[record.dateEntity.date] = record;
                  return acc;
                },
                {},
              );

              return (
                <tr
                  className={`border-b text-center hover:bg-blue-50 transition-colors duration-150 ${
                    index % 2 === 0 ? 'bg-gray-50' : 'bg-white'
                  }`}
                  key={index}
                >
                  <td
                    className={`
                      py-3 px-4 font-medium text-right sticky left-0
                      shadow-[4px_0_6px_-1px_rgba(0,0,0,0.15)]
                      ${index % 2 === 0 ? 'bg-gray-50' : 'bg-white'}
                    `}
                  >
                    {studentName}
                  </td>

                  {allDates.map((date) => {
                    const record = recordsByDate[date];
                    return (
                      <td key={date} className="py-3 px-4">
                        <div className="flex justify-center items-center space-x-4">
                          <span
                            className={`inline-flex items-center justify-center w-6 h-6 rounded-full ${
                              record?.present === true
                                ? 'bg-green-100 text-green-700 font-bold'
                                : record?.present === false
                                  ? 'bg-red-100 text-red-700 font-bold'
                                  : 'bg-gray-100 text-gray-400'
                            }`}
                            title="Present"
                          >
                            {record?.present === true
                              ? '✓'
                              : record?.present === false
                                ? '❌'
                                : '-'}
                          </span>
                          <span
                            className={`inline-flex items-center justify-center w-6 h-6 rounded-full ${
                              record?.homeworkDone
                                ? 'bg-blue-100 text-blue-700 font-bold'
                                : 'bg-gray-100 text-gray-400'
                            }`}
                            title="Homework Done"
                          >
                            {record?.homeworkDone ? '📚' : '-'}
                          </span>
                          <span
                            className={`inline-flex items-center justify-center w-6 h-6 rounded-full ${
                              record?.late
                                ? 'bg-yellow-100 text-yellow-700 font-bold'
                                : 'bg-gray-100 text-gray-400'
                            }`}
                            title="Late"
                          >
                            {record?.late ? '⏰' : '-'}
                          </span>
                          <span
                            className={`inline-flex items-center justify-center w-6 h-6 rounded-full ${
                              record?.disturb
                                ? 'bg-red-100 text-red-700 font-bold'
                                : 'bg-gray-100 text-gray-400'
                            }`}
                            title="Disturbing"
                          >
                            {record?.disturb ? '⚠️' : '-'}
                          </span>
                        </div>
                      </td>
                    );
                  })}
                </tr>
              );
            })}
          </tbody>
        </table>
      </div>
    </div>
  );
};

export default AttendanceTable;
